import {
   Box,
   Breadcrumb,
   BreadcrumbItem,
   BreadcrumbLink,
   Flex,
   Link,
   Text,
   useColorModeValue,
   Input,
   InputGroup,
   InputLeftElement,
   List,
   ListItem,
   HStack,
   Kbd,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalCloseButton,
   useDisclosure,
   Image,
   Popover,
   PopoverTrigger,
   PopoverContent,
   PopoverBody,
   Portal,
   Hide,
   Show,
   useBreakpointValue,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import AdminNavbarLinks from 'components/navbar/NavbarLinksAdmin';
import { SearchBarGlobal } from './searchBar/SearchBarGlobal';
import { SearchIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import {
   masterRoutes,
   purchaseRoutes,
   bankAndCashRoutes,
   saleRoutes,
   otherRoutes,
   itemRoutes,
   transportRoutes,
} from 'routes.js';
import nofound from 'assets/img/nfts/not found.svg';
import { IoMenu } from 'react-icons/io5';
import Sidebar from '../sidebar/Sidebar';
import IconSidebar from '../sidebar/IconSidebar';

export default function AdminNavbar(props) {
   const { isSidebarOpen, setIsSidebarOpen, onSidebarToggle, background, borderRadius, ...rest } = props;
   const [scrolled, setScrolled] = useState(false);
   const { isOpen, onOpen, onClose } = useDisclosure();
   const searchIconColor = useColorModeValue('gray.700', 'black');
   const inputBg = useColorModeValue('secondaryGray.300', 'navy.900');
   const inputText = useColorModeValue('gray.700', 'gray.100');
   const [searchQuery, setSearchQuery] = useState('');
   const [filteredResults, setFilteredResults] = useState([]);
   const inputRef = useRef(null);
   const navigate = useNavigate();
   const [isSearchFocused, setIsSearchFocused] = useState(false);
   const [selectedIndex, setSelectedIndex] = useState(-1); // Track selected result for keyboard navigation

   const isMobileOrTablet = useBreakpointValue({ base: false, lg: true });

   useEffect(() => {
      window.addEventListener('scroll', changeNavbar);

      return () => {
         window.removeEventListener('scroll', changeNavbar);
      };
   });

   const { secondary, message, brandText } = props;

   // Here are all the props that may change depending on navbar's type or state.(secondary, variant, scrolled)
   let mainText = useColorModeValue('navy.700', 'white');
   let secondaryText = useColorModeValue('gray.700', 'white');
   let navbarPosition = 'fixed';
   let navbarFilter = 'none';
   let navbarBackdrop = 'blur(20px)';
   let navbarShadow = 'none';
   let navbarBg = useColorModeValue('rgba(244, 247, 254, 0.2)', 'rgba(11,20,55,0.5)');
   let navbarBorder = 'transparent';
   let secondaryMargin = '0px';
   let paddingX = '0px';
   let gap = '0px';
   const changeNavbar = () => {
      if (window.scrollY > 1) {
         setScrolled(true);
      } else {
         setScrolled(false);
      }
   };

   // Handle Ctrl+Space to toggle search modal
   //  useEffect(() => {
   //  	const handleKeyDown = (event) => {
   //  		if (event.ctrlKey && event.key === " ") {
   //  			event.preventDefault();
   //  			if (!isOpen) onOpen(); // Open the modal search
   //  			else onClose(); // Close if already open
   //  		} else if (event.key === "Escape" && isOpen) {
   //  			onClose();
   //  		}
   //  	};

   //  	window.addEventListener("keydown", handleKeyDown);
   //  	return () => {
   //  		window.removeEventListener("keydown", handleKeyDown);
   //  	};
   //  }, [isOpen, onOpen, onClose]);

   useEffect(() => {
      if (searchQuery) {
         const results = [
            ...masterRoutes,
            ...purchaseRoutes,
            ...bankAndCashRoutes,
            ...saleRoutes,
            ...otherRoutes,
            ...itemRoutes,
            ...transportRoutes,
         ]
            .filter((route) => route.subName && route.subName.trim() !== '')
            .map((route) => ({
               displayName: `${route.subName} : ${route.name}`,
               path: `/admin${route.path}`,
            }))
            .filter((item) => item.displayName.toLowerCase().includes(searchQuery.toLowerCase()));

         setFilteredResults(results);
         // Reset selected index when results change
         setSelectedIndex(-1);
      } else {
         setFilteredResults([]);
      }
   }, [searchQuery]);

   // Close search results when clicking outside
   useEffect(() => {
      function handleClickOutside(event) {
         if (inputRef.current && !inputRef.current.contains(event.target)) {
            setIsSearchFocused(false);
         }
      }

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
         document.removeEventListener('mousedown', handleClickOutside);
      };
   }, [inputRef]);

   // Handle keyboard events (up/down arrows, enter, escape)
   const handleKeyDown = (e) => {
      // Handle only if search is focused and we have results
      if (isSearchFocused && filteredResults.length > 0) {
         switch (e.key) {
            case 'ArrowDown':
               e.preventDefault();
               setSelectedIndex((prev) => (prev < filteredResults.length - 1 ? prev + 1 : prev));
               break;
            case 'ArrowUp':
               e.preventDefault();
               setSelectedIndex((prev) => (prev > 0 ? prev - 1 : 0));
               break;
            case 'Enter':
               e.preventDefault();
               if (selectedIndex >= 0 && selectedIndex < filteredResults.length) {
                  // Navigate to the selected route
                  navigate(filteredResults[selectedIndex].path);
                  setIsSearchFocused(false);
                  setSearchQuery('');
                  onClose(); // Close modal if open
               }
               break;
            default:
               break;
         }
      }
   };

   // Function to navigate to a result
   const navigateToResult = (path) => {
      navigate(path);
      setIsSearchFocused(false);
      setSearchQuery('');
      onClose(); // Close modal if open
   };
   return (
      <>
         {/* {isMobileOrTablet &&
				<Modal isOpen={isOpen} onClose={onClose} size="xl">
					<ModalOverlay />
					<ModalContent>
						<ModalCloseButton />
						<Box p={4} position="relative" ref={inputRef}>
							<InputGroup w="100%">
								<InputLeftElement>
									<SearchIcon color={searchIconColor} w="15px" h="15px" />
								</InputLeftElement>
								<Input
									variant="search"
									fontSize="sm"
									bg={background || inputBg}
									color={inputText}
									fontWeight="500"
									borderRadius={borderRadius || "30px"}
									_placeholder={{ color: "gray.400", fontSize: "14px" }}
									placeholder="Search..."
									value={searchQuery}
									onChange={(e) => setSearchQuery(e.target.value)}
									onFocus={() => setIsSearchFocused(true)}
									onKeyDown={handleKeyDown}
									autoFocus
								/>
								<Box
									position="absolute"
									right="20px"
									top="50%"
									transform="translateY(-50%)"
									color="gray.400"
								>
									<HStack gap="1">
										<Kbd>Esc</Kbd>
									</HStack>
								</Box>
							</InputGroup>

							{searchQuery && (
								<Box
									position="relative"
									bg="white"
									borderRadius="md"
									mt={2}
									maxH="400px"
									overflowY="auto"
								>
									{filteredResults.length > 0 ? (
										<List spacing={2} p={2}>
											{filteredResults.map((result, index) => (
												<ListItem
													key={index}
													p={2}
													borderRadius="md"
													bg={selectedIndex === index ? "gray.300" : "gray.100"}
													color="navy.900"
													_hover={{ bg: "gray.200", cursor: "pointer" }}
													onClick={() => navigateToResult(result.path)}
												>
													{result.displayName}
												</ListItem>
											))}
										</List>
									) : (
										<Box textAlign="center" p={4}>
											<Image
												src={nofound}
												alt="No results"
												boxSize="150px"
												mx="auto"
												mb={3}
											/>
											<Text color="gray.800" fontSize="lg">No results available</Text>
										</Box>
									)}
								</Box>
							)}
						</Box>
					</ModalContent>
				</Modal>
			} */}

         {/* Navbar */}
         <Box
            position={navbarPosition}
            boxShadow={navbarShadow}
            borderColor={navbarBorder}
            filter={navbarFilter}
            backgroundPosition="center"
            backgroundSize="cover"
            borderRadius="16px"
            borderWidth="1.5px"
            borderStyle="solid"
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            // transitionDelay='0s, 0s, 0s, 0s'
            transitionDuration=" 0.15s, 0.15s, 0.15s, 0.15s"
            transition-property="box-shadow, background-color, filter, border"
            transitionTimingFunction="linear, linear, linear, linear"
            alignItems={{ xl: 'center' }}
            display={secondary ? 'block' : 'flex'}
            // minH='75px'
            justifyContent={{ xl: 'Right' }}
            lineHeight="25.6px"
            mx="auto"
            mt={secondaryMargin}
            pb="8px"
            // right={{ base: '12px', md: '30px', lg: '30px', xl: '30px' }}
            left={{ base: 'auto', md: 'auto', lg: 'auto', xl: isSidebarOpen ? '90px' : '240px' }}
            // left="auto"
            px={{
               base: '0px',
               sm: paddingX,
               md: '0px',
            }}
            ps={{
               xl: '0px',
            }}
            pt="0px"
            top={0}
            // top={{ base: '12px', md: '16px', lg: '20px', xl: '20px' }}
            // w={{
            // 	// base: 'calc(100vw - )',
            // 	base: 'calc(100vw - 5%)',
            // 	md: 'calc(100vw - 8%)',
            // 	lg: 'calc(100vw - 6%)',
            // 	xl: 'calc(100vw - 350px)',
            // 	'2xl': isSidebarOpen ? 'calc(100vw - 365px)' : 'calc(100vw - 150px)',
            // 	// '2xl': 'calc(100vw - 365px)',
            // 	// '2xl': 'calc(100vw - 150px)'
            // }}

            w={{
               base: 'calc(100vw - 0%)',
               md: 'calc(100vw - 0%)',
               lg: 'calc(100vw - 0%)',
               xl: isSidebarOpen ? 'calc(100vw - 90px)' : 'calc(100vw - 240px)',
               '2xl': isSidebarOpen ? 'calc(100vw - 90px)' : 'calc(100vw - 240px)',
            }}
            zIndex={100}>
            <Flex
               w="100%"
               flexDirection={{
                  sm: 'column',
                  md: 'row',
               }}
               alignItems={{ xl: 'center' }}
               mb={gap}>
               {/* <IoMenu
						size={28}
						cursor={'pointer'}
						onClick={handleMenuClick}
					/> */}

               {/* Search Bar Trigger - Only visible on large screens */}
               {/* <Show above="lg">
						<Box
							mb={{ sm: '8px', md: '0px' }}
							bg={'white'}
							p={2}
							borderRadius='10px'
							width="30%"
							ml={8}
						>
							<Box position="relative" onClick={onOpen} cursor="pointer">
								<InputGroup w={{ base: "100%", md: "100%" }} {...rest}>
									<InputLeftElement>
										<SearchIcon color="gray.400" w="15px" h="15px" position="absolute"
											right="-20px"
											top="0%"
											transform="translateY(80%)" />
									</InputLeftElement>
									<Input
										variant="search"
										fontSize="sm"
										bg={background || inputBg}
										color={inputText}
										fontWeight="500"
										borderRadius={borderRadius || "30px"}
										_placeholder={{ color: "gray.400", fontSize: "14px" }}
										placeholder="Search..."
										readOnly 
										cursor="pointer"
									/>
									<Box
										position="absolute"
										right="20px"
										top="50%"
										transform="translateY(-50%)"
										color="gray.400"
									>
										<HStack gap="1">
											<Kbd>Ctrl</Kbd>+<Kbd>Space</Kbd>
										</HStack>
									</Box>
								</InputGroup>
							</Box>
						</Box>
					</Show> */}

               <Box ms="auto" ml={'8.5px'} w={{ sm: '100%', md: '100%', xl: '100%' }}>
                  <AdminNavbarLinks
                     onOpen={props.onOpen}
                     logoText={props.logoText}
                     secondary={props.secondary}
                     fixed={props.fixed}
                     isSidebarOpen={isSidebarOpen}
                     setIsSidebarOpen={setIsSidebarOpen}
                     onSidebarToggle={onSidebarToggle}
                     scrolled={scrolled}
                  />
               </Box>
            </Flex>
            {secondary ? <Text color="white">{message}</Text> : null}
         </Box>
      </>
   );
}

AdminNavbar.propTypes = {
   brandText: PropTypes.string,
   variant: PropTypes.string,
   secondary: PropTypes.bool,
   fixed: PropTypes.bool,
   onOpen: PropTypes.func,
   isSidebarOpen: PropTypes.bool,
   onSidebarToggle: PropTypes.func,
};
